import React from 'react'
import styled from 'styled-components'
import SubNav from '../../../common/SubNav'
import GenieTabs from './GenieTabs'
import GenieTable from './GenieTable'
import Pagination from './Pagination'

export default class Dashboard extends React.Component {
  constructor(props) {
    super(props)
    this.tabs = new Map([ // Use a map to guarantee property order
      ['RM', 'Relationship Manager'],
      ['LS', 'Loan Specialist'],
      ['AM', 'Account Manager']
    ])
    this.columns = Object.freeze([ // Freeze this to prevent shenanigans down the line
      { title: 'Name' },
      { title: 'Roles' },
      { title: 'Active Loans',         onClick: () => this.onHeaderClick('numActiveLoans') },
      { title: 'Over Cap?',            onClick: () => this.onHeaderClick('leftUntilCap') },
      { title: '% of Cap',             onClick: () => this.onHeaderClick('percentageOfCap') },
      { title: 'Portfolio Size (mil)', onClick: () => this.onHeaderClick('value') },
      { title: 'SmartRate Average',    onClick: () => this.onHeaderClick('averageSmartRate') },
      { title: 'Today',                onClick: () => this.onHeaderClick('loansAssignedToday') },
      { title: 'Past 4 Days',          onClick: () => this.onHeaderClick('loansLast4') },
      { title: 'Past 30 Days',         onClick: () => this.onHeaderClick('loansLast30') }
    ])
    this.state = {
      role: 'RM',
      order: 'desc',
      sortBy: 'numActiveLoans',
      page: 1,
      perPage: this.getPerPage()
    }
  }
  getPerPage = () => {
    const perPage = parseInt(localStorage.getItem('geniePerPage'), 10)
    if (perPage && typeof perPage === 'number' && !Number.isNaN(perPage)) {
      return perPage
    } else {
      return 10 // Default to 10 per page if the user does not have a preference set
    }
  }
  onHeaderClick = sortBy => {
    if (sortBy === this.state.sortBy) {
      this.toggleSort()
    } else { // If we're sorting on a new column, default to descending order
      this.changeSortBy(sortBy)
      this.setState({ order: 'desc', page: 1 })
    }
  }
  toggleSort = () => {
    const { order } = this.state
    this.setState({
      order: order === 'asc' ? 'desc' : 'asc',
      page: 1
    })
  }
  changeSortBy = sortBy => this.setState({ sortBy })
  changePerPage = perPage => {
    this.setState({
      perPage,
      page: 1
    })
    localStorage.setItem('geniePerPage', perPage)
  }
  changeRole = role => this.setState({ role, page: 1 })
  changePage = page => this.setState({ page })
  next = () => this.setState({ page: this.state.page + 1 })
  prev = () => {
    const { page } = this.state
    const newPage = page - 1
    if (newPage > 0) {
      this.setState({ page: this.state.page - 1 })
    }
  }
  first = () => this.setState({ page: 1 })
  render() {
    const { role, order, perPage, page, sortBy } = this.state
    return (
      <div>
        <SubNav leftLink={{ title: 'Loan Assignments' }} rightLink={{ href: '/admin/genie/pods', title: 'Pods' }} />
        <GenieTabs changeRole={this.changeRole} tabs={this.tabs} currentRole={role} />
        <GenieTable
          perPage={perPage}
          page={page}
          role={role}
          order={order}
          sortBy={sortBy}
          columns={this.columns}
        />
        <Pagination
          currentPage={page}
          changePage={this.changePage}
          changePerPage={this.changePerPage}
          next={this.next}
          first={this.first}
          prev={this.prev}
          perPage={perPage}
          role={role}
        />
      </div>
    )
  }
}
